import dayjs from "dayjs";
import { Series } from "./Series";
import { SHORT_DATE, SHORT_DATE_WITHOUT_YEAR } from "utils/dates";
import type { Event as RawEvent } from "graphql/generated/types.ts";

export const Event = (eventData: RawEvent) => ({
    ...eventData,
    rankingsSeries() {
        return eventData.series.filter(series => Series(series).isRankingsSeries());
    },
    membershipSeries() {
        return eventData.series.filter(series => Series(series).isMembershipSeries());
    },
    shouldHideFinals() {
        return eventData.hideFinals && eventData.status !== "results_published";
    },
    isCompleted() {
        return ["finished", "results_published", "cancelled"].includes(eventData.status);
    },
    isLive() {
        return eventData.status === "on";
    },
    eventDate(shortFormat = false) {
        return eventCardDate(eventData, shortFormat);
    },
    isPublished() {
        return ["published", "on", "on_hold", "finished", "results_published"].includes(eventData.status);
    },
    utcOffset() {
        return eventData.location?.timezone?.utcOffsetMinutes ?? dayjs().utcOffset();
    },
    timezone() {
        return eventData.location?.timezone?.name || null;
    }
});

export function eventCardDate(event: Pick<RawEvent, "date" | "daysWindow">, shortFormat = false) {
    const startDate = dayjs(event.date);
    const endDate = dayjs(event.date).add((event.daysWindow || 1) - 1, "day");
    const dateSuffixFormat = shortFormat ? "MMM" : "MMMM YYYY";

    let text = startDate.format("D");
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    startDate.unix() === endDate.unix() ?
        text += ` ${startDate.format(dateSuffixFormat)}` :
        shortFormat ?
            text += ` ${startDate.format("MMM")} - ${endDate.format(SHORT_DATE_WITHOUT_YEAR)}` :
            startDate.month() === endDate.month() ?
                text += ` - ${endDate.format("D")} ${startDate.format("MMMM YYYY")}` :
                text += ` ${startDate.format("MMM")} - ${endDate.format(SHORT_DATE)}`;

    return text;
}
